import { Routes } from '@angular/router';
import { NotificationContentComponent } from './components/notification-content/notification-content.component';

export const notificationsRoutes: Routes = [
  {
    path     : 'notifications',
    component: NotificationContentComponent
  }
];
